import React, { useEffect, useMemo, useState } from "react";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import "../../styles/custom.css";
import { useFormik } from "formik";
import api from "../../config/URL";
import { toast } from "react-toastify";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net";
import * as Yup from "yup";
import { ThemeProvider, createTheme } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const validationSchema = Yup.object().shape({
  packageId: Yup.string().required("*Package Name is required"),
  day: Yup.string().required("*Date is required"),
});

function StudentRegisterCourse() {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [datas, setDatas] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState({});
  const [courseData, setCourseData] = useState(null);
  const [packageData, setPackageData] = useState(null);
  const [availableDays, setAvailableDays] = useState([]);
  const [loadIndicator, setLoadIndicator] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const centerId = searchParams.get("centerId");
  const [batchData, setBatchData] = useState(null);
  const [startEndDate, setStartEndDate] = useState(null);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        enableHiding: true,
        enableSorting: false,
        size: 50,
        header: "",
        Cell: ({ row }) => (
          <div style={{ textAlign: "center", cursor: "pointer" }}>
            <input
              type="radio"
              style={{ cursor: "pointer" }}
              className="form-check-input pointer"
              name="courseSelection"
              onClick={() => handleRowSelect(row.original)}
            />
          </div>
        ),
      },
      // {
      //   accessorFn: (row, index) => index + 1,
      //   header: "S.NO",
      //   enableSorting: true,
      //   enableHiding: true,
      //   size: 40,
      //   cell: ({ cell }) => (
      //     <span style={{ textAlign: "center" }}>{cell.getValue()}</span>
      //   ),
      // },
      {
        accessorKey: "availableSlots",
        enableHiding: true,
        header: "Available Slots",
        size: 50,
        Cell: ({ cell }) => (
          <div className="d-flex justify-content-center">
            {cell.getValue() ? (
              <span className="badge rounded-pill text-bg-success">
                {cell.getValue()}
              </span>
            ) : (
              <span className="badge rounded-pill text-bg-danger">0</span>
            )}
          </div>
        ),
      },
      {
        accessorKey: "course",
        enableHiding: true,
        header: "Course",
      },
      {
        accessorKey: "className",
        enableHiding: true,
        header: "Class Name",
      },
      { accessorKey: "batch", enableHiding: true, header: "Time", size: 50 },
      {
        accessorKey: "startDate",
        enableHiding: true,
        header: "Start Date",
        size: 50,
      },
      {
        accessorKey: "endDate",
        enableHiding: true,
        header: "End Date",
        size: 50,
      },
      {
        accessorKey: "days",
        enableHiding: true,
        header: "Days",
        size: 50,
      },
      {
        accessorKey: "createdBy",
        header: "Created By",
        Cell: ({ cell }) => cell.getValue() || "",
      },
      {
        accessorKey: "createdAt",
        header: "Created On",
        Cell: ({ cell }) => cell.getValue()?.substring(0, 10),
      },
      {
        accessorKey: "updatedAt",
        header: "Updated On",
        Cell: ({ cell }) => cell.getValue()?.substring(0, 10) || "",
      },
      {
        accessorKey: "updatedBy",
        header: "Updated By",
        Cell: ({ cell }) => cell.getValue() || "",
      },
    ],
    [],
  );

  const theme = createTheme({
    components: {
      MuiTableCell: {
        styleOverrides: {
          head: {
            color: "#535454 !important",
            backgroundColor: "#e6edf7 !important",
            fontWeight: "400 !important",
            fontSize: "13px !important",
            textAlign: "center !important",
          },
        },
      },
      // Switch (Toggle button) customization
      MuiSwitch: {
        styleOverrides: {
          root: {
            "&.Mui-disabled .MuiSwitch-track": {
              backgroundColor: "#f5e1d0", // Track color when disabled
              opacity: 1, // Ensures no opacity reduction
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
              color: "#eb862a", // Thumb (circle) color when disabled
            },
          },
          track: {
            backgroundColor: "#e0e0e0", // Default track color
          },
          thumb: {
            color: "#eb862a", // Default thumb color
          },
          switchBase: {
            "&.Mui-checked": {
              color: "#eb862a", // Thumb color when checked
            },
            "&.Mui-checked + .MuiSwitch-track": {
              backgroundColor: "#eb862a", // Track color when checked
            },
          },
        },
      },
    },
  });

  const formik = useFormik({
    initialValues: {
      lessonName: "",
      packageId: "",
      day: "",
      courseId: "",
      batchs: "",
    },

    validationSchema: validationSchema,
    onSubmit: async (data) => {
      if (!selectedRow) {
        toast.warning("Please select a course");
        return;
      }
      setLoadIndicator(true);
      const payload = {
        ...data,
        studentId: id,
        centerId: selectedRowData.centerId,
        centerName: selectedRowData.centerName,
        classId: selectedRowData.classId,
        className: selectedRowData.className,
        course: selectedRowData.course,
        courseId: selectedRowData.courseId,
        batchId: selectedRowData.batchId,
        batch: selectedRowData.batch,
        days: selectedRowData.days,
        classRoom: selectedRowData.classRoom,
        startDate: data.day,
        endDate: selectedRowData.endDate,
        studentCount: selectedRowData.studentCount,
        teacher: selectedRowData.teacher,
        userId: selectedRowData.userId,
        lessonName: data.day,
      };
      console.log("Payload Data:", payload);
      try {
        const response = await api.post(
          `/createStudentCourseDetails`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (response.status === 200 || response.status === 201) {
          toast.success(response.data.message);
          // navigate("/student");
          navigate(`/invoice/add?studentID=${id}`);
          formik.resetForm();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        if (error?.response?.status === 409) {
          toast.warning(error?.response?.data?.message);
        } else if (error?.response?.status === 404) {
          toast.warning(error?.response?.data?.message);
        } else {
          toast.error(error?.response?.data?.message);
        }
      } finally {
        setLoadIndicator(false);
      }
    },
  });

  const fetchCourseData = async () => {
    try {
      const response = await api.get(
        `getCourseIdsAndNamesByCenterId/${centerId}?studentId=${id}`,
      );
      setCourseData(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchPackageData = async () => {
    // Ensure that both centerId and courseId are present in selectedRowData
    if (!selectedRowData.centerId || !selectedRowData.courseId) {
      console.log(
        "Both Center ID and Course ID are required to fetch packages",
      );
      return;
    }

    try {
      const response = await api.get(
        `/courseFeeAvailablePackages?centerId=${selectedRowData.centerId}&courseId=${selectedRowData.courseId}`,
      );
      setPackageData(response.data);
      console.log("Fetched Package Data:", response.data); // For debugging
    } catch (error) {
      toast.error(error.message || "Failed to fetch packages");
    }
  };

  const fetchStartandEndDate = async () => {
    // Ensure that both centerId and courseId are present in selectedRowData
    if (!selectedRowData.classId) {
      return;
    }

    try {
      const response = await api.get(
        `/getScheduledStartDates?classId=${selectedRowData.classId}`,
      );
      setStartEndDate(response.data);
      console.log("Fetched Package Data:", response.data); // For debugging
    } catch (error) {
      toast.error(error.message || "Failed to fetch packages");
    }
  };

  // Call fetchPackageData when selectedRowData changes
  useEffect(() => {
    fetchPackageData();
    fetchStartandEndDate();
  }, [selectedRowData]);

  useEffect(() => {
    fetchCourseData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = async () => {
    setLoading(true);
    let params = {};

    if (formik.values.courseId !== "") {
      params.courseId = formik.values.courseId;
    }

    if (formik.values.day !== "") {
      params.day = formik.values.day;
    }

    if (formik.values.batchs !== "") {
      params.batchs = formik.values.batchs;
    }

    try {
      const response = await api.get(
        `/getCourseClassListingTeachers/${centerId}`,
        {
          params,
        },
      );
      setDatas(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [formik.values.courseId, formik.values.batchs, formik.values.day]);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await api.get(`/getAllStudentById/${id}`);
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleRowSelect = (data) => {
    if (data.availableSlots === 0) {
      toast.warning("Class is Full");
      return; // Prevent further actions
    }

    setSelectedRow(data.id); // Save selected row ID
    setSelectedRowData(data); // Save selected row data
    console.log("Selected Row Data:", data); // Log selected row data for debugging

    // Calculate days between startDate and endDate
    if (data.startDate && data.endDate) {
      const days = calculateDays(data.startDate, data.endDate, data.days);
      setAvailableDays(days); // Update available days
    } else {
      setAvailableDays([]);
    }
  };

  const calculateDays = (startDate, endDate, selectedDay) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const days = [];

    // Mapping selected day string to its corresponding numeric value
    const dayMapping = {
      SUNDAY: 0,
      MONDAY: 1,
      TUESDAY: 2,
      WEDNESDAY: 3,
      THURSDAY: 4,
      FRIDAY: 5,
      SATURDAY: 6,
    };

    const targetDay = dayMapping[selectedDay.toUpperCase()];

    for (
      let date = new Date(start);
      date <= end;
      date.setDate(date.getDate() + 1)
    ) {
      if (date.getDay() === targetDay) {
        days.push({
          value: date.toISOString().split("T")[0],
          label: date.toDateString(),
        });
      }
    }

    return days;
  };

  const fetchBatchandTeacherData = async (day) => {
    try {
      const response = await api.get(
        `getTeacherWithBatchListByDay?date=${day}`,
      );
      setBatchData(response.data.batchList);
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    if (formik.values.day) {
      fetchBatchandTeacherData(formik.values.day);
    }
  }, [formik.values.day]);

  const formatTo12Hour = (time) => {
    const [hours, minutes] = time.split(":");
    let period = "AM";
    let hour = parseInt(hours, 10);

    if (hour === 0) {
      hour = 12;
    } else if (hour >= 12) {
      period = "PM";
      if (hour > 12) hour -= 12;
    }

    return `${hour}:${minutes} ${period}`;
  };

  const normalizeTime = (time) => {
    if (time.includes("AM") || time.includes("PM")) {
      return time;
    }

    return formatTo12Hour(time);
  };

  const convertTo24Hour = (time) => {
    const [timePart, modifier] = time.split(" ");
    let [hours, minutes] = timePart.split(":").map(Number);

    if (modifier === "PM" && hours < 12) {
      hours += 12;
    } else if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0",
    )}`;
  };

  return (
    <div className="container-fluid">
      <ol
        className="breadcrumb my-3 px-2"
        style={{ listStyle: "none", padding: 0, margin: 0 }}
      >
        <li>
          <Link to="/" className="custom-breadcrumb">
            Home
          </Link>
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li>
          &nbsp;Student Management
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li>
          <Link to="/student" className="custom-breadcrumb">
            &nbsp;Student Listing{" "}
          </Link>
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li>
          <Link to={`/student/view/${id}`} className="custom-breadcrumb">
            &nbsp;Student View
          </Link>
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          &nbsp;Student Course Detail
        </li>
      </ol>
      <form
        onSubmit={formik.handleSubmit}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !formik.isSubmitting) {
            e.preventDefault(); // Prevent default form submission
          }
        }}
      >
        <div className="card">
          <div
            className="d-flex justify-content-between align-items-center p-1 mb-4 px-4"
            style={{ background: "#f5f7f9" }}
          >
            <div className="d-flex align-items-center">
              <div className="d-flex">
                <div className="dot active"></div>
              </div>
              <span className="me-2 text-muted">Course Detail</span>
            </div>
            <div className="my-2 pe-3 d-flex align-items-center">
              <Link to={`/student/view/${id}`}>
                <button type="button " className="btn btn-sm btn-border">
                  Back
                </button>
              </Link>
              &nbsp;&nbsp;
              <button type="submit" className="btn btn-button btn-sm">
                <span className="fw-medium">Update</span>
              </button>
            </div>
          </div>
          <div className="p-2">
            <table className="table table-border-solid">
              <thead>
                <tr>
                  <th scope="col" className="fw-medium">
                    S.No
                  </th>
                  <th scope="col" className="fw-medium">
                    Current Course
                  </th>
                  <th scope="col" className="fw-medium">
                    Time
                  </th>
                  <th scope="col" className="fw-medium">
                    Days
                  </th>
                  <th scope="col" className="fw-medium">
                    Package
                  </th>
                  <th scope="col" className="fw-medium">
                    Lesson Start Date
                  </th>
                  <th scope="col" className="fw-medium">
                    Lesson End Date
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.studentCourseDetailModels &&
                  data.studentCourseDetailModels.map((stdCourse, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{stdCourse.course || "--"}</td>
                      <td>{stdCourse.batch || "--"}</td>
                      <td>{stdCourse.days || "--"}</td>
                      <td>{stdCourse.packageName || "--"}</td>
                      <td>{stdCourse.lessonName || "--"}</td>
                      <td>{stdCourse.endDate || "--"}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="border-0 my-2 px-2">
            <div className="row mt-2">
              <div className="col-md-4">
                <select
                  {...formik.getFieldProps("courseId")}
                  className={`form-select  ${
                    formik.touched.courseId && formik.errors.courseId
                      ? "is-invalid"
                      : ""
                  }`}
                  id="courseId"
                  name="courseId"
                >
                  <option value="" disabled selected>
                    Select Course
                  </option>
                  {courseData &&
                    courseData.map((course) => (
                      <option key={course.id} value={course.id}>
                        {course.courseNames}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-4">
                <DatePicker
                  dateFormat="yyyy-MM-dd"
                  className={`form-control w-100 ${
                    formik.touched.day && formik.errors.day ? "is-invalid" : ""
                  }`}
                  placeholderText="Select Date"
                  selected={
                    formik.values.day ? new Date(formik.values.day) : null
                  }
                  // onChange={(date) => {
                  //   const formattedDate = date
                  //     ? date.toISOString().split("T")[0]
                  //     : "";

                  //   formik.setFieldValue("day", formattedDate);
                  //   setAvailableDays([]);
                  // }}
                  onChange={(date) => {
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const day = String(date.getDate()).padStart(2, "0");

                    const formattedDate = `${year}-${month}-${day}`;

                    formik.setFieldValue("day", formattedDate);
                    setAvailableDays([]);
                  }}
                  showMonthDropdown
                  showYearDropdown
                  popperClassName="student-datepicker-popper"
                  calendarClassName="student-react-datepicker"
                  wrapperClassName="student-react-datepicker-wrapper"
                />
                {formik.touched.day && formik.errors.day && (
                  <div className="text-danger">{formik.errors.day}</div>
                )}
              </div>

              <div className="col-md-4 d-flex">
                <select
                  {...formik.getFieldProps("batchs")}
                  className="form-select"
                  id="batchs"
                  name="batchs"
                >
                  <option value="">Select Time</option>
                  {batchData &&
                    batchData.map((time) => {
                      const displayTime = normalizeTime(time);
                      const valueTime =
                        time.includes("AM") || time.includes("PM")
                          ? convertTo24Hour(time)
                          : time;

                      return (
                        <option key={time} value={valueTime}>
                          {displayTime}
                        </option>
                      );
                    })}
                </select>
                <button
                  type="button"
                  className="btn btn-sm border-secondary ms-3 my-1"
                  style={{ width: "100px" }}
                  onClick={() =>
                    formik.resetForm({
                      values: {
                        lessonName: "",
                        packageId: "",
                        courseId: "",
                        day: "",
                        batchs: "",
                      },
                    })
                  }
                >
                  Clear
                </button>
              </div>
            </div>
            {/* ScheduleTeachers Table */}
            <div className="container my-4">
              {loading ? (
                <div className="loader-container">
                  <div className="loading">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              ) : (
                <>
                  <ThemeProvider theme={theme}>
                    <MaterialReactTable
                      columns={columns}
                      data={datas}
                      enableColumnActions={false}
                      enableColumnFilters={false}
                      enableDensityToggle={false}
                      enableFullScreenToggle={false}
                      initialState={{
                        columnVisibility: {
                          createdBy: false,
                          createdAt: false,
                          updatedBy: false,
                          updatedAt: false,
                        },
                      }}
                    />
                  </ThemeProvider>
                </>
              )}
            </div>
            <div className="row mt-2">
              <div className="col-md-4">
                <select
                  {...formik.getFieldProps("packageId")}
                  className={`form-select  ${
                    formik.touched.packageId && formik.errors.packageId
                      ? "is-invalid"
                      : ""
                  }`}
                  id="packageId"
                  name="packageId"
                >
                  <option value="" disabled selected>
                    Select Package
                  </option>
                  {packageData &&
                    packageData.map((pkg) => (
                      <option key={pkg.packageId} value={pkg.packageId}>
                        {pkg.packageName}
                      </option>
                    ))}
                </select>
                {formik.touched.packageId && formik.errors.packageId && (
                  <div className="invalid-feedback">
                    {formik.errors.packageId}
                  </div>
                )}
              </div>

              {/* {availableDays.length > 0 && (
                <div className="col-md-4">
                  <select
                    {...formik.getFieldProps("lessonName")}
                    className={`form-select  ${
                      formik.touched.lessonName && formik.errors.lessonName
                        ? "is-invalid"
                        : ""
                    }`}
                    id="lessonName"
                    name="lessonName"
                  >
                    <option value="" disabled selected>
                      Select Lesson Name
                    </option>
                    {startEndDate &&
                      startEndDate.map((seDate) => (
                        <option key={seDate.date} value={seDate.date}>
                          {seDate.showDate}
                        </option>
                      ))}
                  </select>
                  {formik.touched.lessonName && formik.errors.lessonName && (
                    <div className="invalid-feedback">
                      {formik.errors.lessonName}
                    </div>
                  )}
                </div>
              )} */}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default StudentRegisterCourse;
